export enum Pages {
    'art',
    'recent'
}